import {
    RESET_LOAD_PROGRESS_SETTINGS,
    SET_LOAD_PROGRESS_SETTINGS,
    TOGGLE_LOADING,
    TOGGLE_LOAD_PROGRESS_BAR
} from './actionTypes';

export const resetLoadProgress = payload => ({
    type: RESET_LOAD_PROGRESS_SETTINGS
});

export const setLoadProgress = payload => ({
    type: SET_LOAD_PROGRESS_SETTINGS,
    payload
});

export const toggleLoading = isLoading => ({
    type:    TOGGLE_LOADING,
    payload: isLoading
});

export const toggleLoadProgressBar = payload => ({
    type: TOGGLE_LOAD_PROGRESS_BAR,
    payload
});
